import React, { Component } from "react"
import { Grid } from "@material-ui/core"
import styled from "@emotion/styled"
import GridWrapper from "../../atoms/GridWrapper"
import RowGrid from "../../atoms/RowGrid"
import KatahiraHouse from "../../../images/katahira_house.jpg"

const Text = styled.span(
  {
    fontFamily: "Avenir Next",
    color: "#ffffff",
  },
  props => ({
    fontWeight: props.fontWeight,
    fontSize: props.fontSize,
    textAlign: props.textAlign,
    textDecoration: props.textDecoration,
  })
)

export default class Top extends Component {
  render() {
    return (
      <GridWrapper
        height={700}
        style={{
          backgroundImage: `url(${KatahiraHouse})`,
          backgroundSize: "cover",
        }}
      >
        <Grid>
          <RowGrid style={{ padding: "10px 20px" }}>
            <Text fontSize={60} fontWeight={"bold"}>
              Brandを
            </Text>
            <Text fontSize={60} fontWeight={"bold"}>
              科学する
            </Text>
          </RowGrid>
        </Grid>
      </GridWrapper>
    )
  }
}
